module.exports = __webpack_public_path__ + "static/media/card-AMX.6a75752c.svg";